<script>
  import { format } from 'svelte-i18n';

  import { AUDIT_HISTORY_TYPES } from '@client/enums';

  export let row = {};

  $: type = row.type;
</script>

<div class="badge-{type}">{$format(AUDIT_HISTORY_TYPES[type]?.label || type)}</div>

<style lang="scss">
  [class*='badge-'] {
    border: 1px solid var(--color-gray-500);
    border-radius: var(--border-radius-base);
    color: var(--color-gray-600);
    display: inline-block;
    font-size: var(--font-size-xsmall);
    font-weight: var(--font-weight-medium);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;
  }
</style>
